<template>
  <div id="app">
    <nav-cmd v-if="flage"></nav-cmd>
    <router-view></router-view>
    <footer-cmd v-if="flage"></footer-cmd>
  </div>
</template>

<script>
import navCmd from "@/components/home/common/nav.vue";
import footerCmd from "@/components/home/common/footer.vue";
export default {
  name: 'home',
  computed: {},
  watch:{
    '$route.path'(newValue, oldValue) {
　　　　 this.flage = !(newValue.includes('pay-list'))
　　 }
  },
  data(){
    return { flage : true}
  },
  components: {
    navCmd,
    footerCmd
  }
}
</script>

<style lang="scss">
  /*样式清零*/
  body,ul,ol,dl,dt,dd,h1,h2,h3,h4,h5,h6,p,input{
    margin: 0; padding: 0;
  }
  li {
    list-style: none;
  }
  img {
    border: 0;
  }
  a{
    text-decoration: none;
  }
  .clearfix:after {display: block; content: ""; clear: both;}
  .fl{float: left;}
  .fr{float: right;}
  body, button, input, optgroup, select, textarea {
    font: 12px/1.5 PingFangSC-Regular,PingFangSC-Medium,PingFangSC-Light,arial,Helvetica Neue,tahoma,"Hiragino Sans GB",Microsoft YaHei,\5b8b\4f53;
  }
  body {min-width: 1170px;font-family: PingFangSC-Regular;}
</style>


